import { ReplaceAroundStep, ReplaceStep } from '@atlaskit/editor-prosemirror/transform';
export var trackSyncBlocks = function trackSyncBlocks(storeManager, tr, state) {
  var sourceSyncBlockRemoved = {};
  var sourceSyncBlockAdded = {};

  // and cast to specific step types
  var replaceSteps = tr.steps.filter(function (step) {
    return step instanceof ReplaceStep || step instanceof ReplaceAroundStep;
  });
  replaceSteps.forEach(function (step) {
    var from = step.from,
      to = step.to;
    // replaced a range, check for deleted syncBlock

    if (from !== to) {
      step.getMap().forEach(function (oldStart, oldEnd) {
        if (oldStart !== oldEnd) {
          var deletedSlice = state.doc.slice(oldStart, oldEnd);
          deletedSlice.content.nodesBetween(0, deletedSlice.content.size, function (node) {
            if (storeManager.isSourceBlock(node)) {
              if (sourceSyncBlockAdded[node.attrs.localId]) {
                // If a source block added and then removed in the same transaction,
                // we treat it as no-op.
                delete sourceSyncBlockAdded[node.attrs.localId];
              } else {
                sourceSyncBlockRemoved[node.attrs.localId] = node.attrs;
              }
            }
            // we don't need to go deeper
            return false;
          });
        }
      });
    }

    // replaced content, check for inserted syncBlock
    // if only one replace step, we have already checked the entire replaced range above
    if (step.slice.content.size > 0) {
      step.slice.content.nodesBetween(0, step.slice.content.size, function (node) {
        if (storeManager.isSourceBlock(node)) {
          if (sourceSyncBlockRemoved[node.attrs.localId]) {
            // If a source block is removed and added back in the same transaction,
            // we treat it as no-op.
            delete sourceSyncBlockRemoved[node.attrs.localId];
          } else {
            sourceSyncBlockAdded[node.attrs.localId] = node.attrs;
          }
        }
        // we don't need to go deeper
        return false;
      });
    }
  });
  return {
    removed: Object.values(sourceSyncBlockRemoved),
    added: Object.values(sourceSyncBlockAdded)
  };
};